module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Save_16"],"path":[{"$":{"d":"M11,10H5V9h6Zm0,1H5v1h6Zm4-7V15H1V1H12ZM4,2V6h8V2H11V5H9V2Zm9,6H3v5H13Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Save_16.svg
// module id = zef4
// module chunks = 1